/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { PagedResponse } from '../../core/store/general/models/general';
import {
  CaseById,
  CreateCase,
  SupportCenter,
} from '../../core/store/support-center/models/SupportCenter';

@Injectable({
  providedIn: 'root',
})
export class SupportCenterService {
  private baseApiUrl: string = environment.API_BASE_URL + '/support';
  constructor(private readonly http: HttpClient) {}

  getSupport(
    status?: string,
    pageNumber?: number,
    pageSize?: number,
    searchTerm?: string,
    sortBy?: string,
    sortDescending?: boolean,
  ): Observable<PagedResponse<SupportCenter>> {
    let params = new HttpParams();
    if (status) {
      params = params.set('status', status);
    }
    if (pageNumber) {
      params = params.set('pageNumber', pageNumber);
    }
    if (pageSize) {
      params = params.set('pageSize', pageSize);
    }
    if (searchTerm) {
      params = params.set('searchTerm', searchTerm);
    }
    if (sortBy) {
      params = params.set('sortBy', sortBy);
    }
    if (sortDescending !== undefined) {
      params = params.set('sortDescending', sortDescending);
    }
    return this.http.get<PagedResponse<SupportCenter>>(`${this.baseApiUrl}`, {
      params,
    });
  }

  createSupportCase(body: CreateCase): Observable<any> {
    return this.http.post(`${this.baseApiUrl}/add-ticket`, body);
  }

  getCaseById(id: string): Observable<CaseById> {
    return this.http.get<CaseById>(`${this.baseApiUrl}/${id}`);
  }

  replyToCase(ticketId: string, message: string): Observable<any> {
    const body = { ticketId, message };
    return this.http.post(`${this.baseApiUrl}/reply-to-ticket`, body);
  }

  closeCase(id: string): Observable<any> {
    return this.http.post(`${this.baseApiUrl}/close`, { id });
  }
}
